  export const defaultSetting = {
    name: "لطفا شکیبا باشید",
    logoImageAddress: "",
    fax: "۰۲۱۵۴۶۶۵۹۲۳۱",
    address:
      "تهران - خیابان شریعتی - نرسیده به پل سید خندان - ورودی ۲۲ - ساختمان مرکزی",
    latitudeAndLongitude: "1N,32E",
    sliderImageCount: 4,
    homePageNewsCount: 4,
    tell: "۰۲۱۵۴۶۶۵۹۲۳۱",
    postalCode: "۱۱۱۱۱۱۱۱۱",
    telegramAddress: "https://telegram.me",
    whatsappAddress: "https://whatsapp.com",
    instagramAddress: "https://instagram.com",
    facebookAddress: "https://facebook.com",
    twitterAddress: "https://twitter.com",
  };